export default function yelpRatingConverter(rating) {
  const [full, decimal] = rating.toString().split('.');
  return `${full}${decimal ? 'half' : ''}`;
}
